<input #inputEl class="smart-input price-input"
  type="text"
  [value]="displayValue"
  [disabled]="isDisabled"
  (focus)="onFocus($event)"
  (input)="onInput($event)"
  (blur)="onBlur()">

